export const SHOW_BAR = 'showBar';
export const CLOSE_BAR = 'closeBar';
export const CLEAR_OFERTAS = 'clearOfertas';
export const ADD_OFERTA = 'addOferta';
export const REMOVE_OFERTA = 'removeOferta';
export const LOAD_INITIAL_STATE = 'loadInitialState';
